import { apiFetch } from "@/lib/apiClient";

export interface MonthlyVolumePoint {
  month: string;
  volume: number;
  netProfit: number;
  commission: number;
}

export interface TopMerchant {
  id: string;
  dbaName: string;
  mid: string;
  city: string | null;
  state: string | null;
  ownerName: string;
  netVolume: number;
  netProfit: number;
  commission: number;
}

export interface DashboardSummary {
  merchantCount: number;
  openMerchantCount: number;
  ytdNetVolume: number;
  ytdNetProfit: number;
  ytdUserCommission: number;
  ytdTickets: number;
  ytdChargebackCount: number;
  monthlyVolume: MonthlyVolumePoint[];
  topMerchants: TopMerchant[];

  myOpenTicketCount: number;

  myOverdueTicketCount: number;
}

interface MonthlyVolumePointResponse {
  month: string;
  volume: number;
  profit: number;
  commission: number;
}

interface TopMerchantItem {
  id: string;
  dbaName: string | null;
  mid: string | null;
  city: string | null;
  state: string | null;
  ownerName: string | null;
  volume: number;
  profit: number;
  commission: number;
}

interface DashboardSummaryResponse {
  merchantCount: number;
  openMerchantCount: number;
  ytdVolume: number;
  ytdProfit: number;
  ytdCommission: number;
  ytdTicketCount: number;
  ytdChargebackCount: number;
  monthlyPoints: MonthlyVolumePointResponse[];
  topMerchants: TopMerchantItem[];
  myOpenTickets: number;
  myOverdueTickets: number;
}

function toSummary(r: DashboardSummaryResponse): DashboardSummary {
  return {
    merchantCount: r.merchantCount ?? 0,
    openMerchantCount: r.openMerchantCount ?? 0,
    ytdNetVolume: r.ytdVolume ?? 0,
    ytdNetProfit: r.ytdProfit ?? 0,
    ytdUserCommission: r.ytdCommission ?? 0,
    ytdTickets: r.ytdTicketCount ?? 0,
    ytdChargebackCount: r.ytdChargebackCount ?? 0,
    monthlyVolume: (r.monthlyPoints ?? []).map((p) => ({
      month: p.month,
      volume: p.volume ?? 0,
      netProfit: p.profit ?? 0,
      commission: p.commission ?? 0,
    })),
    topMerchants: (r.topMerchants ?? []).map((m) => ({
      id: m.id,
      dbaName: m.dbaName ?? "",
      mid: m.mid ?? "",
      city: m.city ?? null,
      state: m.state ?? null,
      ownerName: m.ownerName ?? "",
      netVolume: m.volume ?? 0,
      netProfit: m.profit ?? 0,
      commission: m.commission ?? 0,
    })),
    myOpenTicketCount: r.myOpenTickets ?? 0,
    myOverdueTicketCount: r.myOverdueTickets ?? 0,
  };
}

export const dashboard = {
  async summary() {
    const r = await apiFetch<DashboardSummaryResponse>("/dashboard/summary");
    return toSummary(r);
  },
};
